import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAppContext, screenBreakpoints } from 'App/app-context';
import styles from './style.module.less';
const PrimaryAddButton = ({ id, label, onClick, className, }) => {
    const { screenSize } = useAppContext();
    const showLabel = screenSize.width >= screenBreakpoints.sm;
    return (_jsx(Button, { id: id, icon: _jsx(PlusOutlined, { className: styles.plusIcon }), type: "primary", className: className, onClick: onClick, children: showLabel && _jsx("span", { className: styles.label, children: label }) }));
};
export default PrimaryAddButton;
